<template>
  <PageTemplate>
    <Loader v-if="!isLoaded"/>
    <div v-else>
      <div class="d-flex justify-content-between">
        <h6 class="element-header">
          Online-Benutzer
        </h6>
      </div>

      <div class="element-box">
        <h5 class="form-header mb-4">
          Online-Benutzerliste  ( {{count}} )
        </h5>

        <EmptyState
            v-if="!onlineUsers.length"
            icon="fa-user-clock"
            title="Keine Benutzer online"/>

        <div v-else class="table-responsive overflow-auto pt-4">
          <table class="table table-striped">
            <thead>
            <tr>
              <th>Vorname</th>
              <th>Nachname</th>
              <th>Rechte</th>
              <th>Anstellungsart</th>
              <th>Email</th>
              <th>Zuletzt gesehen</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(user) in onlineUsers" :key="user.email">
              <td>{{ user?.firstName }}</td>
              <td>{{ user?.lastName }}</td>
              <td>{{ user?.accessRight }}</td>
              <td>{{ user?.engagementType }}</td>
              <td>{{ user?.email }}</td>
              <td>{{ user?.lastSeen }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </PageTemplate>
</template>


<script setup>
import {CloseToast, ErrorToast} from '@/components/VueToast';
import EmptyState from '@/components/EmptyState.vue';
import Loader from '@/components/Loader.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import {onMounted, ref} from 'vue';
import onlineUsersService from "@/api/OnlineUsers";

const onlineUsers = ref([]);
const count = ref(0)
const isLoaded = ref(false);

async function getOnlineUsers() {
  CloseToast();

  try {
    const {data} = await onlineUsersService.getOnlineUsers();
    onlineUsers.value = data.data.onlineUsers;
    count.value = data.data.count;
  } catch (error) {
    await ErrorToast(error);
  }
}

onMounted(async () => {
  await getOnlineUsers()
  isLoaded.value = true;
});

</script>

<style scoped>

</style>